import jwtAuthAxios from "./auth/jwtAuth";

// Estado de las integraciones por cliente. Ver hermes-backend app/controllers/api/v1/integration_status_controller.rb.
const integrationStatusServices = {};

// Lo que Haulers ya sabe (credenciales, ultimo pedido, jobs, cuentas ML, cookie Relbase). Instantaneo.
integrationStatusServices.overview = async () => (await jwtAuthAxios.get("/integration_status")).data;

// Prueba en vivo contra cada proveedor. Sin ids prueba todas; force salta la cache de 5 min.
integrationStatusServices.checks = async ({ ids, force } = {}) => {
    const params = {};
    if (ids && ids.length) params.ids = ids.join(",");
    if (force) params.force = 1;
    return (await jwtAuthAxios.get("/integration_status/checks", { params, timeout: 60000 })).data.data;
};

export default integrationStatusServices;
